import qs from 'qs'

const fields = [
]

export const queryEducationEntryBySlug = (options: QueryBySlugOrIdOptions) => {
  const searchKey = strapiGetI18nSlug(options.locale)

  const query = qs.stringify(
    {
      publicationState: options?.publicationState || 'live',
      locale: options?.locale || 'en-US',
      pagination: {
        limit: 1,
      },
      filters: {
        slugs: {
          [searchKey]: {
            $eq: options.slug
          }
        }
      },
      fields,
      populate: {
        ...queryFragmentCollectionTypeDefault,
        ...queryFragmentBlocks,
        entries: {
          populate: {
            titles: true,
            subtitles: true,
            descriptions: true,
            images: true
          }
        }
      }
    },
    {
      encodeValuesOnly: true
    }
  )

  return `education-entries?${query}`
}
